// extracted by mini-css-extract-plugin
export var alignRight = "component-module--alignRight--4eb2b";
export var buttonContainer = "component-module--buttonContainer--f03d9";
export var contact = "component-module--contact--867a7";
export var contactContainer = "component-module--contactContainer--164b4";
export var container = "component-module--container--7b512";
export var ctaButtonDark = "component-module--ctaButtonDark--3df58";
export var ctaButtonLight = "component-module--ctaButtonLight--fdfc1";
export var dark = "component-module--dark--b6928";
export var heading = "component-module--heading--3e09c";
export var light = "component-module--light--bdcc2";
export var media = "component-module--media--ea3e1";
export var tagline = "component-module--tagline--ad852";